<template>
    <div class="indoorIndex" >
        <div id="mapTop" style="width:100%;height:100%"></div>
        <!-- 顶部分类 -->
        <div class="categoryTop"  style="z-index:9999">
            <div class="categoryName" :id="`cateGory${index}`" @click="selectCate(item,index)" v-for="(item,index) in VoiceCategory" :key="index">
                <img class="imagesIcon" :style="selectOption == index?'transform: translateY(-200px);filter: drop-shadow(0px 200px  0 #E67008);':'color:#707070'" v-if="item.icon" :src="item.icon" alt="">
                <span class="cateName" :style="selectOption == index?'color:#E67008;font-weight: 900;':'color:#707070'">{{item.name}}</span>
            </div>
        </div>
        <!-- 左下角选项 -->
        <div class="LToption" v-if="RToptionShow"  style="z-index:9999">
            <!-- 楼层选择 -->
            <div class="FloorSelectionChild" @click="clickEnter" v-if="indoorCoverage.length != 1" :style="ShowHide == true?'border-radius:0 0 0.2rem 0.2rem;':'border-radius:0.2rem'">
                <img class="images" src="../assets/F1.png" alt="">
                <div class="FloorSelectionChildF">F{{indoorCoverage.length - selectHide}}</div>
                <div class="floorOptions" v-if="ShowHide == true" style="z-index:99999">
                    <div class="coverageMark" :style="selectHide==index?'background:#E67008;color:white':''" v-for="(item,index) in indoorCoverage" :key="index" @click="checkedBtn(index)" >
                        <span class="markSpa">F{{indoorCoverage.length - index}}</span>
                    </div>
                </div>
            </div>
            <!-- 线路 -->
            <div class="FloorSelectionChild " @click="openCourse" style="margin-top:0.12rem">
                <img class="ChildPlus" src="../assets/luxian2.png" alt="">
            </div>
            <!-- 搜索景点 -->
            <div class="FloorSelection">
                <img class="images" @click="searchOpen" src="../assets/sarche.png" alt="">
            </div>
        </div>
        <!-- 右上角选项 -->
        <div class="RToption"  style="z-index:9999">
            <div class="RToptionCen">
                <div class="RToptionCenTop XX" @click="briefIntroduction">
                    <img class="imageCen" src="../assets/tuceng1.png" alt="">
                </div>
                <div class="RToptionCenName">简介</div>
            </div>
            <!-- <div class="RToptionCen" @click="shopping" v-if="indoorDeailsData.link">
                <div class="RToptionCenTop SC">
                    <img class="imageCen"  src="../assets/shangcheng1.png" alt="">
                </div>
                <div class="RToptionCenName">商城</div>
            </div> -->
            <div class="RToptionCen" @click="shopping" v-if="indoorDeailsData.link">
                <div class="RToptionCenTop SC">
                    <img class="imageCen"  src="../assets/haitan.png" alt="">
                </div>
                <div class="RToptionCenName">园区</div>
            </div>
            <div class="RToptionCen"  @click="jumpVR" v-if="indoorDeailsData.vr_link">
                <div class="RToptionCenTop XL">
                    <img class="imageCen" src="../assets/vr.png" alt="">
                </div>
                <div class="RToptionCenName">VR</div>
            </div>
            <div class="RToptionCen"  @click="consult" v-if="indoorDeailsData.hot_link">
                <div class="RToptionCenTop ZX">
                    <img class="imageCen" src="../assets/zixun.png" alt="">
                </div>
                <div class="RToptionCenName">资讯</div>
            </div>
        </div>
        <!-- 公告 -->
        <div class="announcement" v-if="indoorDeailsData.notice">
            <van-notice-bar
                left-icon="volume-o" scrollable   color="#E67008" background="#fff" style="border-radius: 0.22rem;height:0.3rem"
                :text="indoorDeailsData.notice"
            />
        </div>
        <!-- 下方弹出层 -->
        <van-popup 
            v-model="showOption" 
            :overlay="overlay"
            position="bottom" 
            :lock-scroll="lockScroll"
            :style="{ height: showOptionHeigth,zIndex:'999999'}" 
            >
            <div class="playBack" style="z-index:9999" >
                <div class="ZKandSH" v-if="showOptionHeigth == '2rem'" @click="unfold">展&nbsp;&nbsp;&nbsp;&nbsp;开</div>
                <div class="ZKandSH" v-if="showOptionHeigth == '5rem'" @click="takeBack">收&nbsp;&nbsp;&nbsp;&nbsp;回</div>
                <div class="closeWin" @click="closeWin">
                    <img style="width:100%;height:100%" src="../assets/close.png" alt="">
                </div>
                <div class="player">
                    <div class="playerTop">
                        <div class="playerTopLeft">
                            <img style="width:100%;height:100%;border-radius: 0.25rem;" :src="URL + pointInformationData.img" alt="">
                        </div>
                        <div class="playerTopRig">
                            <div class="playerName">{{pointInformationData.name }}</div>
                            <div class="playPlan">
                                <div class="playPlanL1">
                                    <img src="../assets/leftJT.png" alt="">
                                </div>
                                <div class="playPlanL2">{{currentTimeStr|| '00:00'}}</div>
                                <div class="playPlanC">
                                    <mt-range 
                                        style="width:100%;height:0.2rem"
                                        v-model="currentTime"
                                        :max="totleTime||1"
                                        :min="0"
                                        disabled
                                        :bar-height="1"
                                    ></mt-range>
                                </div>
                                <div class="playPlanR1" v-if="totleTimeStr!='NaN:NaN'">{{totleTimeStr|| '99:99'}}</div>
                                <div class="playPlanR1" v-if="totleTimeStr=='NaN:NaN'">99:99</div>

                                <div class="playPlanR2">
                                    <img src="../assets/rigJT.png" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="playerBtmID" v-if="scenicSpotsID && pointInformationData.id!=scenicSpotsID || tolerantData.id">
                        <div class="goToThisPlace" @click="goThere">
                            <img src="../assets/lujing.png" alt="">
                            去这里
                        </div>
                        <div class="playerBtmExplain" @click="PlayAudio">
                            <img v-if="isPlay == false" src="../assets/bofang.png" alt="">
                            <img v-if="isPlay == true" src="../assets/zanting.png" alt="">
                            &nbsp;导&nbsp;览&nbsp;讲&nbsp;解
                        </div>
                    </div>
                    <div class="playerBtm" @click="PlayAudio" v-else>
                        <img v-if="isPlay == false" src="../assets/bofang.png" alt="">
                        <img v-if="isPlay == true" src="../assets/zanting.png" alt="">
                        &nbsp;导&nbsp;览&nbsp;讲&nbsp;解
                    </div>
                    <audio controls ref="maudit" v-show="false" :src="url" />
                </div>
                
            </div>
            <div class="Information">
                <div class="JDmessage">&nbsp;景点信息</div>
                <div class="vrBackImg">
                    <div class="vrImgBack">
                        <div class="vrImg" @click="openVR" v-if="pointInformationData.link_vr" :style="'background: url('+ URL + pointInformationData.img_vr +');background-size: 100% 100%;'">
                            <img style="width:100%;height:100%;border-radius: 0.15rem;" src="../assets/vrQJ.png" alt="">
                        </div>
                        <div class="backImg" @click="clickOverlay">
                            <img class="backImgImages" :src="URL + pointInformationData.img" alt="">
                        </div>
                    </div>
                    <div class="scenicJD" v-html="pointInformationData.intro"></div>
                    <div class="examineMore" @click="examineMore" v-if="pointInformationData.link_spot">
                        查看更多>>
                    </div>
                </div>
            </div>
        </van-popup>
        <!--  搜索弹出层  -->
        <van-popup v-model="searchShow"   position="left" :overlay="overlay"  :style="{ zIndex:'999999 !important' ,width: '100%' ,height:'100%',padding:'0rem'}"
            >
            <div style="width:100%;height:100%;background:white;display: flex;flex-direction: column;">
                <form action="/">
                    <van-search
                        v-model="searchValue"
                        shape='round'
                        show-action
                        placeholder="请输入搜索关键词"
                        @search="onSearch"
                        @cancel="onCancel"
                        @clear="searchClear"
                        clear-trigger="always"
                    />
                </form>
                <div class="serchList" v-if="seekData.length!==0">
                    <div v-if="seekData.length != 0" class="searchList" :style="{height:clickHeight}">
                        <div  v-for="(item,index) in seekData" :key="index" @click="openSearch(item)">
                            <div class="serveDetails" >
                                <div class="searchIcon">
                                    <img class="Icons" :src="item.icon" alt="">
                                </div>
                                <div class="serveName">
                                    {{item.name}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <van-tabs animated v-model="activeVoiceID"  color="#E67008" @click="activeVoice()" v-if="seekData.length == 0">
                    <van-tab v-for="item in VoiceCategory" :key="item.id" :title="item.name" >
                        <div v-if="activeCategoryData.length == 0" class="notAvailable">---当前分类下暂无景点---</div>
                        <div v-if="activeCategoryData.length != 0" class="searchList" :style="{height:clickHeight}">
                            <div  v-for="(item,index) in activeCategoryData" :key="index" @click="openSearch(item)">
                                <div class="serveDetails"  >
                                    <div class="searchIcon">
                                        <img class="Icons" :src="item.icon" alt="">
                                    </div>
                                    <div class="serveName">
                                        {{item.name}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </van-tab>
                </van-tabs>
            </div>
        </van-popup>
        <!--  路线搜索  -->
        <van-popup v-model="chartCourseShow" position="left" :overlay="overlay"  :style="{zIndex:'9999999 !important', width: '100%' ,height:'100%',padding:'0rem'}">
            <div class="chartCourseP" >
                <div class="chartCourseM">
                    <div class="chartCourseTop">
                        <div class="getBack" @click="getBackCourse">
                            <img class="images" src="../assets/fanhui.png" alt="">
                        </div>
                        <div class="chartCourseName">
                            <div class="chartCourseNameTop NameTop">
                                <div class="chartCourseNameLeft nameLeft">
                                </div>
                                <div class="chartCourseNameRig" @click="inputInception">
                                    <input type="text"  v-model="inception" class="courseInp"  placeholder="请选择起点" ref="saveTagInput">
                                </div>
                            </div>
                            <div class="chartCourseNameTop ">
                                <div class="chartCourseNameLeft nameRig">
                                </div>
                                <div class="chartCourseNameRig" @click="inputDestination">
                                    <input type="text" v-model="destination" class="courseInp"  placeholder="请选择终点">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="goToPlace">
                        <div class="goToButton" @click="goHere">去这里&nbsp;&nbsp;&nbsp;
                            <img class="goToImage" src="../assets/quzheli.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="chartDetails" v-if="courseScenicData.length != 0">
                    <div class="chartDetailsList" v-for="(item,index) in courseScenicData" :key="index" @click="chartDetailsOpen(item)">
                        <div class="chartDetailsIcon">
                            <img style="width:100%;height:100%" src="../assets/LXdingwei.png" alt="">
                        </div>
                        <div class="chartDetailsName">
                            {{item.name}}
                        </div>
                        <div class="chartDetailsImage">
                            <img style="width:100%;height:100%" src="../assets/jiantouLeftTop.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="chartDetailsPlus" v-if="courseScenicData.length == 0">
                    <div class="zanwu">--- 暂无相关路线 ---</div>
                </div>
            </div>
        </van-popup>
        <!-- 右下角退出路线 -->
        <div class="exitRoute" @click="exitRoute" v-if="CurrentShow  == true" style="z-index:9008">
            退出线路
        </div>
        <!--  图片放大预览 -->
        <van-overlay :show="overlayShow" @click="overlayShow = false" z-index='999999'>
            <div class="wrapper"  @click="overlayShow = false" >
                <img class="wrapperImg" :src="URL + pointInformationData.img" alt="" @click="overlayShow = false"  > 
            </div>
        </van-overlay>
        <!-- loading -->
        <div v-if="blankShow == true" style="position:fixed;top:0px;width:100%;height:100%;background:white;z-index:99999999"></div>
        <img  v-if="loadingShow == true" style="width:250px;height:250px;position:fixed;top:calc(50% - 100px);left:calc(50% - 125px);z-index:999999999" src="../assets/12.gif" alt="">
    </div>
</template>

<script>
import { getIndoorGuide,getVoiceCategory ,getVoiceSpots,getIndoorVoiceRoute} from '../api/api'
import getUrlKey from '@/utils/getUrlKey'
import { Toast } from 'vant';
import $ from 'jquery'
export default {
    name: 'indoorIndexs',
    data() {
        return {
            scenicSpotsID: getUrlKey(window.location.search).scenicSpotsID,         //  扫码进来景点的id
            URL: process.env.BASE_IMG_API,
            indoorId:getUrlKey(window.location.search).indoorId,                    //  导览id
            goToThisPlace:require('../assets/zixun.png'),
            qidian:require('../assets/qidian.png'),
            zhongdian:require('../assets/zhongdian.png'),
            indoorDeailsData:'',            //  导览信息
            selectHide:0,
            VoiceCategory:[],               //  分类
            servicePointShow:false,
            ShowHide:false,
            selectOption:'0',               //  分类选中下标
            atPresentCategory:[],           //  当前分类
            currentCoverage:'',             //  当前图层
            RToptionShow:true,              //  是否显示左下角选项
            indoorCoverage:[],              //  导览图层
            showOption:false,               //  是否弹出遮罩层
            showOptionHeigth:'2rem',
            overlay:false,
            lockScroll:false,
            isPlay:false,
            totleTime: 0,
            currentTime: 0,
            currentTimeStr: '',
            totleTimeStr: '',
            pointInformationData:{},
            overlayShow:false,             
            searchValue:'',                 //  搜索内容
            searchShow:false,               //  搜索弹出层
            activeCategoryData:{},          //  搜索选中列表
            seekData:[],                    //  搜索出来的景点
            activeVoiceID:'',               //  选中导航栏id
            courseScenicData:[],            //  初始路线点位
            indoorDataList:[],              
            inception:'',                   //  起点
            destination:'',                 //  终点
            chartCourseShow:false,          //  显示隐藏绘制路线
            selectInput:1,                  //  当前选中的input
            CurrentRelevant:[],             //  当前路线
            inceptionDetails:'',            //  起点信息
            destinationDetails:'',          //  终点信息
            tolerantData:{},                //  默认起点信息
            zindexData:'99999',
            clickHeight:'',
            loadingShow:false,
            blankShow:false,
            CurrentShow:false,
            storageIndex:[],
            searchData:'',
            searchSelets:'',
        };
    },
    computed: {
        url() {
            return this.URL + this.pointInformationData.sound;
        },
    },
    watch:{
        inception(newVal,oldVal){
            clearTimeout(this.timeout);
            // this.timeout = setTimeout(()=>{
            //     this.inputSearchData(newVal)
            // },300)
        },
        destination(newVal,oldVal){
            clearTimeout(this.timeout);
            // this.timeout = setTimeout(()=>{
            //     this.bbb(newVal)
            // },300)
        },
        courseScenicData(val){
            this.courseScenicData = val
        },
        indoorDataList(val){
            this.indoorDataList = val
        }
    },
    created(){
        this.loadingShow = true
        this.blankShow = true
        this.gainIndoorDetails()            //  获取导览信息
        var sss = (document.documentElement.clientHeight - 160)/100
        this.clickHeight = sss+'rem'
    },
    mounted() {
    },
    methods: {
        //  获取导览图层的默认起点
        tolerantStart(){
            const data = {
                filter: `[{"explanatio_id":${this.indoorId}},{"map_img_id":${this.currentCoverage.id}}]`
            }
            getVoiceSpots(data).then((res)=>{
                for(var i = 0 ; i <res.data.items.length ; i++){
                    if(res.data.items[i].type == 2){
                        this.tolerantData = res.data.items[i]
                    }
                }
            })
        },
        //  获取导览信息
        gainIndoorDetails(){
            getIndoorGuide(this.indoorId).then((res)=>{
                this.indoorDeailsData = res.data
                this.indoorCoverage = res.data.map_img
                this.selectHide = this.indoorCoverage.length-1
                this.storageIndex.push(this.indoorCoverage.length-1)
                this.currentCoverage = this.indoorCoverage[this.indoorCoverage.length-1]
                getVoiceCategory({ filter: `[{"explanatio_id":${this.indoorId}}]`}).then((res)=>{
                    this.VoiceCategory = res.data.items
                    this.atPresentCategory = res.data.items[0]
                    this.initMap()
                })
                if(!this.scenicSpotsID){
                    this.tolerantStart()
                }
            })
        },
        //  点击顶部分类
        selectCate(item,index){
            this.infoServerMap.close();//初始关闭信息窗关闭
            for(var i = 0 ; i < this.atScenicSpot.length ; i++){
                this.MultiMarker[i].setMap(null)
            }
            this.servicePointShow = false
            this.selectOption = index
            this.atPresentCategory = item,
            this.getVoiceSpotsData()
            this.scrollIntoView(`cateGory${index}`)
        },
          //  控制滚动条滚动
        scrollIntoView(id) {
            let element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({
                    block: 'center',
                    inline:'center'
                });
            }
        },
        //   获取当前楼层 当前分类下的所有景点
        getVoiceSpotsData(){
            const data = {
                filter: `[{"explanatio_id":${this.indoorId}},{"category_id":${this.atPresentCategory.id}},{"map_img_id":${this.currentCoverage.id}}]`
            }
            getVoiceSpots(data).then((res)=>{
                // this.$set(this.atScenicSpot ,'', res.data.items);
                this.atScenicSpot = res.data.items
                this.establishSign()
            })
        },
         //  跳转简介
        briefIntroduction(){
            this.$router.push({
                path:"/brief",
                query:{
                    indoorInformation:this.indoorDeailsData
                }
            })
        },
        //  跳转商城
        shopping(){
            window.open(this.indoorDeailsData.link)
        },
        //  跳转VR
        jumpVR(){
            window.open(this.indoorDeailsData.vr_link)
        },
         //  跳转资讯
        consult(){
            window.open(this.indoorDeailsData.hot_link)
        },
        //  选择楼层
        clickEnter(){
            this.servicePointShow = false
            if(this.ShowHide == false){
                this.ShowHide = true
            }else{
                this.ShowHide = false
            }
        },
        //  点击楼层
        checkedBtn(index){
            if(this.storageIndex.includes(index)){
                
                }else{
                this.storageIndex.push(index)
                this.loadingShow = true
                this.blankShow = true
            }
            this.tolerantData = {}
            for(var i = 0 ; i < this.atScenicSpot.length ; i++){
                this.MultiMarker[i].setMap(null)
            }
            this.CurrentShow = false
            this.CurrentRelevant=[]
            this.selectHide = index
            this.currentCoverage = this.indoorCoverage[index]
            this.getVoiceSpotsData()
            // this.map.setCenter( new TMap.LatLng(this.indoorDeailsData.map_img[this.selectHide].coordinate.split(',')[1],this.indoorDeailsData.map_img[this.selectHide].coordinate.split(',')[0]))
            this.map.setZoom(11)
            this.chartlet()
            this.tolerantStart()
            this.exitRoute()
        },
        //  点击路线
        openCourse(){
            this.chartCourseShow = true
            // const routeData = [];
            this.indoorDataList = []
            this.courseScenicData = []
            this.servicePointShow = false
            // const data1 = {
            //     filter: `[{"explanatio_id":${this.indoorId}}]`
            // }
            // getIndoorVoiceRoute(data1).then((res)=>{
            //     for(var i = 0 ; i<res.data.items.length ; i++){
            //         routeData.push(res.data.items[i].start)
            //     }
            //     const data = {
            //         filter: `[{"explanatio_id":${this.indoorId}},{"map_img_id":${this.currentCoverage.id}}]`
            //     }
            //     getVoiceSpots(data).then((res)=>{
            //         for(var i = 0 ; i<res.data.items.length;i++){
            //             if(res.data.items[i].type != 2 && routeData.includes(res.data.items[i].id)){
            //                 this.courseScenicData.push(res.data.items[i])
            //                 this.indoorDataList.push(res.data.items[i])
            //             }
            //         }
            //     })
            // })
            this.inputSearchData('')
            this.inception = ''
            this.destination = ''
            this.selectInput = 1
            let that = this
            this.$nextTick(function () {
                that.$refs.saveTagInput.focus();
            });
        },
        getBackCourse(){
            this.chartCourseShow = false
        },
        //  点击起点input框
        inputInception(){
            this.selectInput = 1
            this.inputSearchData('')
        },
        //  点击终点input框
        inputDestination(){
            this.selectInput = 2
            this.courseScenicData = []
            // this.inputSearchData('')
            this.acquire()
        },
        acquire(val){
            this.courseScenicData = []
            const data = {
                filter: `[{"explanatio_id":${this.indoorId}},{"map_img_id":${this.currentCoverage.id}},{"name":"${this.inception}"}]`
            }
            getVoiceSpots(data).then((res)=>{
                if(res.data.items.length == 0){
                    Toast('暂无相关起点');
                }else{
                    this.inceptionDetails = res.data.items[0]
                }
                const data = {
                    filter: `[{"explanatio_id":${this.indoorId}},{"start":${this.inceptionDetails.id}}]`
                }
                getIndoorVoiceRoute(data).then((res)=>{
                    console.log(this.indoorDataList,'打印this.indoorDataList')
                    console.log(res.data.items,'打印res.data.items')
                    for(var i = 0 ; i <this.indoorDataList.length;i++){
                        for(var j = 0 ; j<res.data.items.length;j++){
                            if(this.indoorDataList[i].id == res.data.items[j].end){
                                this.courseScenicData.push(this.indoorDataList[i])
                            }
                        }
                    }
                })
            })
        },
        //  选中列表中的景点
        chartDetailsOpen(item){
            if(this.selectInput == 1){
                this.inception = item.name
            }
            if(this.selectInput == 2){
                this.destination = item.name
            }
        },
         //  input搜索
        inputSearchData(val){
            this.courseScenicData = []
            // this.indoorDataList=[]
            // const routeData = []
            // const data1 = {
                // filter: `[{"explanatio_id":${this.indoorId}}]`,
            // }
            // getIndoorVoiceRoute(data1).then((res)=>{
            // for(var i = 0 ; i<res.data.items.length ; i++){
            //     routeData.push(res.data.items[i].start)
            // }
                const data1 = {
                    filter: `[{"explanatio_id":${this.indoorId}},{"map_img_id":${this.currentCoverage.id}},["like","name","${val}"]]`,
                }
                getVoiceSpots(data1).then((res)=>{
                    this.indoorDataList = res.data.items
                })
                const data = {
                    filter: `[{"explanatio_id":${this.indoorId}},{"map_img_id":${this.currentCoverage.id}},["like","name","${val}"]]`,
                    path:'path',
                }
                getVoiceSpots(data).then((res)=>{
                    this.courseScenicData = res.data.items
                // this.indoorDataList = res.data.items
                // for(var i = 0 ; i<res.data.items.length;i++){
                //     if(res.data.items[i].type != 2 && routeData.includes(res.data.items[i].id)){
                //         console.log(res.data.items[i],'打印res.data.items[i]')
                        // this.courseScenicData.push(res.data.items[i])
                //     }
                // }
                })
            // })




            // const data = {
            //     filter: `[{"explanatio_id":${this.indoorId}},{"map_img_id":${this.currentCoverage.id}},["like","name","${val}"]]`
            // }
            // getVoiceSpots(data).then((res)=>{
            //     if(res.data.items.length == 0){
            //         Toast('暂无相关景点');
            //     }else{
            //         for(var i = 0 ; i<res.data.items.length ; i++){
            //             if(res.data.items[i].type != 2){
            //                 this.courseScenicData.push(res.data.items[i])
            //             }
            //         }
            //     }
            // })
        },
         //  点击去这里
        goHere(){
            if(this.inception!=''){
                const data = {
                    filter: `[{"explanatio_id":${this.indoorId}},{"map_img_id":${this.currentCoverage.id}},{"name":"${this.inception}"}]`
                }
                getVoiceSpots(data).then((res)=>{
                    if(res.data.items.length == 0){
                        Toast('暂无相关起点');
                    }else{
                        this.inceptionDetails = res.data.items[0]
                        if(this.destination!=''){
                            const datas = {
                                filter: `[{"explanatio_id":${this.indoorId}},{"map_img_id":${this.currentCoverage.id}},{"name":"${this.destination}"}]`
                            }
                            getVoiceSpots(datas).then((res)=>{
                                if(res.data.items.length == 0){
                                    Toast('暂无相关终点');
                                }else{
                                    this.destinationDetails = res.data.items[0]
                                    this.routeAcquisition()
                                }
                            })
                        }else{
                            Toast('请选择终点');
                        }
                    }
                })
            }else{
                Toast('请选择起点');
            }
        },
        //  绘制路线
        routeAcquisition(){
            const data = {
                filter: `[{"explanatio_id":${this.indoorId}},{"start":${this.inceptionDetails.id}},{"end":"${this.destinationDetails.id}"}]`
            }
            getIndoorVoiceRoute(data).then((res)=>{
                if(res.data.items.length == 0){
                    Toast('暂无导航路线，请重新选择起点或终点');
                }else{
                    this.CurrentRelevant = res.data.items[0]
                    this.drawPath()
                }
            })
        },
        drawPath(){
            const that = this
            if(this.polyline){
                this.polyline.setMap(null)
            }
            if(this.markerLayer){
                this.markerLayer.setMap(null)
            }
            let data = []
            for(var i = 0 ; i <this.CurrentRelevant.route.length;i++){
                data.push(new TMap.LatLng(this.CurrentRelevant.route[i].x,this.CurrentRelevant.route[i].y))
            }
            this.polyline = new TMap.MultiPolyline({
                id: 'polyline-layer',
                map: this.map,
                styles: {
                    'polyline': new TMap.PolylineStyle({
                        'color': '#63D97E', //线填充色
                        'width':10, //折线宽度
                        'borderWidth': 1, //边线宽度
                        'borderColor': 'rgba(0,125,255,0.5)', //边线颜色
                        'lineCap': 'round', //线端头方式
                        'showArrow':true
                    }),
                },
                geometries: [
                    {
                        'id': 'polyline', //折线图形数据的标志信息
                        'styleId': 'polyline', //样式id
                        'paths': data, //折线的位置信息
                        'properties': { //折线的属性数据
                            'title': 'customStyle'
                        }
                    },
                ]
            });
            this.markerLayer = new TMap.MultiMarker({ 
                id: 'marker-layer',
                map: this.map,
                zIndex:999999,
                styles: {
                    "start": new TMap.MarkerStyle({
                        "width": 34,
                        "height": 34,
                        "anchor": { x: 17.5, y: 30},
                        "src": this.qidian
                    }),
                    "end": new TMap.MarkerStyle({
                        "width": 34,
                        "height": 34,
                        "anchor": { x: 17.5, y: 30 },
                        "src": this.zhongdian
                    })
                },
                geometries: [{
                    "id": 'start',
                    "styleId": 'start',
                    "position": new TMap.LatLng(this.CurrentRelevant.route[0].x,this.CurrentRelevant.route[0].y)
                }, {
                    "id": 'end',
                    "styleId": 'end',
                    "position": new TMap.LatLng(this.CurrentRelevant.route[this.CurrentRelevant.route.length - 1].x,this.CurrentRelevant.route[this.CurrentRelevant.route.length - 1].y)
                }]
            });
            this.CurrentShow = true
            this.markerLayer.on('click',function(event){
                if(event.geometry.id == "start"){
                    that.map.easeTo({center:event.geometry.position})
                    for(var j = 0 ; j < that.atScenicSpot.length ; j++){
                        if(that.atScenicSpot[j].id == that.CurrentRelevant.start && that.atScenicSpot[j].type == 1){
                            that.pointInformationData = that.atScenicSpot[j]
                            that.servicePointShow = false
                            that.showOption = true
                            that.CurrentShow = false
                            that.RToptionShow = false
                            setTimeout(()=>{
                                let audio = that.$refs['maudit'];
                                that.totleTime = audio.duration;
                                that.totleTimeStr = that.formatTime(audio.duration);
                            },600)
                            that.takeBack()
                        }
                        if(that.atScenicSpot[j].id == that.CurrentRelevant.start  && that.atScenicSpot[j].type == 0){
                            that.infoWindows.open();
                            that.infoWindows.setPosition(event.geometry.position);//设置信息窗位置
                            that.infoWindows.setContent(event.geometry.position.toString());
                        }
                    }
                }
                if(event.geometry.id == "end"){
                    that.map.easeTo({center:event.geometry.position})
                    for(var j = 0 ; j < that.atScenicSpot.length ; j++){
                        if(that.atScenicSpot[j].id == that.CurrentRelevant.end && that.atScenicSpot[j].type == 1){
                            that.pointInformationData = that.atScenicSpot[j]
                            that.servicePointShow = false
                            that.showOption = true
                            that.CurrentShow = false
                            that.RToptionShow = false
                            setTimeout(()=>{
                                let audio = that.$refs['maudit'];
                                that.totleTime = audio.duration;
                                that.totleTimeStr = that.formatTime(audio.duration);
                            },600)
                            that.takeBack()
                        }
                        if(that.atScenicSpot[j].id == that.CurrentRelevant.end  && that.atScenicSpot[j].type == 0){
                            that.infoWindows.open();
                            that.infoWindows.setPosition(event.geometry.position);//设置信息窗位置
                            that.infoWindows.setContent(event.geometry.position.toString());
                        }
                    }
                }
            })
            this.chartCourseShow = false
            
        },
        exitRoute(){
            this.polyline.setMap(null)
            this.markerLayer.setMap(null)
            this.CurrentRelevant = []
            this.CurrentShow = false
        },
        //  搜索景点
        searchOpen(){
            this.servicePointShow = false
            this.searchClear()
            this.searchValue = ''
            this.searchShow = true
            const data = {
                filter: `[{"explanatio_id":${this.indoorId}},{"category_id":${this.VoiceCategory[this.activeVoiceID || 0].id}},{"map_img_id":${this.currentCoverage.id}}]`
            }
            getVoiceSpots(data).then((res)=>{
                this.activeCategoryData = res.data.items
            })
        },
        activeVoice(){
            const data = {
                filter: `[{"explanatio_id":${this.indoorId}},{"category_id":${this.VoiceCategory[this.activeVoiceID].id}},{"map_img_id":${this.currentCoverage.id}}]`
            }
            getVoiceSpots(data).then((res)=>{
                this.activeCategoryData = res.data.items
            })
        },
        //  搜索框点击取消
        onCancel(){
            this.searchShow = false
        },
        searchClear(){
            this.seekData=[]
        },
        //  搜索框点击搜索
        onSearch(val) {
            const data = {
                filter: `[{"explanatio_id":${this.indoorId}},["like","name","${this.searchValue}"]]`
            }
            getVoiceSpots(data).then((res)=>{
                if(res.data.items.length == 0){
                    Toast('暂无相关景点');
                }else{
                    this.seekData = res.data.items
                }
            })
        },
         //  搜索景点 点击
        openSearch(item){
            this.searchData = item
            this.searchSelets = 'search'
            for(var i = 0 ; i < this.atScenicSpot.length ; i++){
                this.MultiMarker[i].setMap(null)
            }
            let that = this
            // this.CurrentShow = true
            this.CurrentRelevant = []
            for(var i = 0;i<this.VoiceCategory.length;i++){
                if(this.VoiceCategory[i].id == item.category_id){
                        this.selectCate(this.VoiceCategory[i],i)
                    // this.selectOption = i
                    this.map.easeTo({center:new TMap.LatLng(
                                item.coordinate.split(',')[1], 
                                item.coordinate.split(',')[0])})
                    // this.atPresentCategory = this.VoiceCategory[i]
                    // this.getVoiceSpotsData()



                    //  定位后弹出信息框
                    
                    // this.MultiMarker[i].on('click',function(event){
                    // that.map.easeTo({center:event.geometry.position})
                    // })
                }
            }
            this.searchShow = false
        },
        //  创建地图
        initMap() {
            const that = this
            var center = new TMap.LatLng(39.924515, 116.416755)
            //定义map变量，调用 TMap.Map() 构造函数创建地图
            this.map = new TMap.Map(document.getElementById("mapTop"), {
                center: center,//设置地图中心点坐标
                zoom:11,	//缩放级别
                minZoom:10,
                maxZoom:20,
                viewMode:"2D",
                showControl:false,
                baseMap: {
                    features:["base","road"],
                },
            });
            //  去除左下角logo 和 下面信息
            var a = document.querySelector('canvas+div>div:last-child')
            a.style.display = 'none'
            this.map.on('tilesloaded',function(){
                that.loadingShow = false
                that.blankShow = false
            })
            this.chartlet()
            this.getVoiceSpotsData(this.atPresentCategory,0)
            this.infoServerMap()
        },
        //  初始化信息窗口
        infoServerMap(){
            const that = this
            this.infoServerMap = new TMap.InfoWindow({
                map: this.map,
                position: new TMap.LatLng(39.69194811636234 , 116.29606741114696),
                offset: { x: 0, y: -32 }, //设置信息窗相对position偏移像素
                enableCustom: true,
                zIndex:9999999,
                content: 'Hello World!'
            });
            this.infoServerMap.close();//初始关闭信息窗关闭
        },
        //  贴图
        chartlet(){
            var ne = new TMap.LatLng(this.indoorDeailsData.map_img[this.selectHide].boundary.northwest.split(',')[1], this.indoorDeailsData.map_img[this.selectHide].boundary.southeast.split(',')[0]);//东北角坐标
            var sw = new TMap.LatLng(this.indoorDeailsData.map_img[this.selectHide].boundary.southeast.split(',')[1], this.indoorDeailsData.map_img[this.selectHide].boundary.northwest.split(',')[0]);//西南角坐标
            this.boundary = new TMap.LatLngBounds(sw, ne)
            this.map.setBoundary(this.boundary);
            //  贴图
            var boundaryArr = [
                [Number(this.indoorDeailsData.map_img[this.selectHide].boundary.southeast.split(',')[1]), Number(this.indoorDeailsData.map_img[this.selectHide].boundary.southeast.split(',')[0])],
                [Number(this.indoorDeailsData.map_img[this.selectHide].boundary.northwest.split(',')[1]), Number(this.indoorDeailsData.map_img[this.selectHide].boundary.northwest.split(',')[0])]
            ]
            let minlongitude = boundaryArr[1][0];
            let minlatitude = boundaryArr[0][1];
            let maxlongitude = boundaryArr[0][0];
            let maxlatitude = boundaryArr[1][1];
            this.earthlayer = []
            let arrlength = this.indoorDeailsData.map_img[this.selectHide].map_imgs.length;
            let sprtNum = Math.sqrt(arrlength);
            for(var i = 0 ; i <arrlength; i++ ){
                // i = 0
                // 余数
                let num = (i + 1) % sprtNum;
                // 若为零取平方根
                if (num === 0) num = sprtNum;
                // 总共列数
                let column = arrlength / sprtNum;
                // 当前行数
                let row = (i + 1 - num) / sprtNum + 1;

                let sw = new TMap.LatLng(
                minlongitude + ((maxlongitude - minlongitude) / sprtNum) * (row - 1),
                maxlatitude - ((maxlatitude - minlatitude) / sprtNum) * num
                );
                let ne = new TMap.LatLng(
                minlongitude + ((maxlongitude - minlongitude) / sprtNum) * row,
                maxlatitude - ((maxlatitude - minlatitude) / sprtNum) * (num - 1)
                );
                let boundaryPlus = new TMap.LatLngBounds(ne,sw);
                this.earthlayer.push(
                    new TMap.ImageGroundLayer({
                        map: this.map,
                        visible: true,
                        zIndex: 1,
                        src: `${this.URL + this.indoorDeailsData.map_img[this.selectHide].map_imgs[i]}`,
                        bounds: boundaryPlus,
                        minZoom: 1,
                        maxZoom: 21,
                    })
                );
            }
            
        },
        searchEstable(){
            this.searchSelets = ''
            let that = this
            for(var j = 0 ; j < that.atScenicSpot.length ; j++){
                        if(that.atScenicSpot[j].id == that.searchData.id ){
                            if( that.searchData.type == 1){
                                that.infoServerMap.close();//初始关闭信息窗关闭
                                that.pointInformationData = that.atScenicSpot[j]
                                that.servicePointShow = false
                                that.showOption = true
                                that.CurrentShow = false
                                that.RToptionShow = false
                                setTimeout(()=>{
                                    let audio = that.$refs['maudit'];
                                    that.totleTime = audio.duration;
                                    that.totleTimeStr = that.formatTime(audio.duration);
                                },600)
                                that.takeBack()
                            }
                            if(that.searchData.type == '0' ){
                                that.infoServerMap.open();
                                that.infoServerMap.setPosition(new TMap.LatLng(
                                    that.searchData.coordinate.split(',')[1], 
                                    that.searchData.coordinate.split(',')[0]));//设置信息窗位置
                                that.infoServerMap.setContent(`
                                <div style=" font-size: 13px;height:18px" id="tabDaolan">
                                    <img src="http://f.xiaoniren.cn/upload/ditu/icon/daohang.png" style="width: 18px; height: 18px" alt="">
                                    <span style=" margin-left: 10px; vertical-align: top;">
                                        去这里
                                    </span>
                                </div>`);
                                $("#tabDaolan").on("click",()=>{
                                    that.infoServerMap.close();//初始关闭信息窗关闭
                                    if(that.scenicSpotsID){
                                        const data = {
                                            filter: `[{"explanatio_id":${that.indoorId}},{"start":${that.scenicSpotsID}},{"end":"${item.id}"}]`
                                        }
                                        getIndoorVoiceRoute(data).then((res)=>{
                                            if(res.data.items.length == 0){
                                                Toast('暂无导航路线，请重新选择起点或终点');
                                            }else{
                                                that.CurrentRelevant = res.data.items[0]
                                                that.drawPath()
                                            }
                                        })
                                    }
                                    if(that.tolerantData.id){
                                        const data = {
                                            filter: `[{"explanatio_id":${that.indoorId}},{"start":${that.tolerantData.id}},{"end":"${item.id}"}]`
                                        }
                                        getIndoorVoiceRoute(data).then((res)=>{
                                            if(res.data.items.length == 0){
                                                Toast('暂无导航路线，请重新选择起点或终点');
                                            }else{
                                                that.CurrentRelevant = res.data.items[0]
                                                that.drawPath()
                                            }
                                        })
                                    }
                                });
                            }
                        }

                    }
        },
        //  点标记
        establishSign(){
            this.MultiMarker = []
            let that = this
            for(var i = 0 ; i < this.atScenicSpot.length ; i++){
                this.MultiMarker[i]=new TMap.MultiMarker({
                    id:this.atScenicSpot[i].id,
                    map: this.map, // 显示Marker图层的底图
                    styles: {
                        small: new TMap.MarkerStyle({
                            // 点标注的相关样式
                            width: 34,
                            height: 34,
                            anchor: { x: 17.5, y: 30 },
                            src: this.atScenicSpot[i].icon, // 标注点图片url或base64地址
                            color: '#E67008', // 标注点文本颜色
                            size: 16, // 标注点文本文字大小
                            direction: 'bottom', // 标注点文本文字相对于标注点图片的方位
                            offset: { x: 0, y: 8 }, // 标注点文本文字基于direction方位的偏移属性
                            strokeColor: '#FFFFFF', // 标注点文本描边颜色
                            strokeWidth: 1, // 标注点文本描边宽度
                        }),
                    },
                    geometries: [
                        {
                            styleId: 'small', // 对应中的样式id
                            position: new TMap.LatLng(
                                this.atScenicSpot[i].coordinate.split(',')[1], 
                                this.atScenicSpot[i].coordinate.split(',')[0]), // 标注点位置
                            content: this.atScenicSpot[i].name, // 标注点文本
                        },
                    ],
                    zIndex:99999,
                })
                this.MultiMarker[i].on('click',function(event){
                    that.map.easeTo({center:event.geometry.position})
                    for(var j = 0 ; j < that.atScenicSpot.length ; j++){
                        if(that.atScenicSpot[j].id == event.target.id && that.atScenicSpot[j].type == 1){
                            that.infoServerMap.close();//初始关闭信息窗关闭
                            that.pointInformationData = that.atScenicSpot[j]
                            that.servicePointShow = false
                            that.showOption = true
                            that.CurrentShow = false
                            that.RToptionShow = false
                            setTimeout(()=>{
                                let audio = that.$refs['maudit'];
                                that.totleTime = audio.duration;
                                that.totleTimeStr = that.formatTime(audio.duration);
                            },600)
                            that.takeBack()
                        }
                        if(that.atScenicSpot[j].id == event.target.id && that.atScenicSpot[j].type == 0 ){
                            that.infoServerMap.open();
                            that.infoServerMap.setPosition(event.geometry.position);//设置信息窗位置
                            that.infoServerMap.setContent(`
                            <div style=" font-size: 13px;height:18px" id="tabDaolan">
                                <img src="http://f.xiaoniren.cn/upload/ditu/icon/daohang.png" style="width: 18px; height: 18px" alt="">
                                <span style=" margin-left: 10px; vertical-align: top;">
                                    去这里
                                </span>
                            </div>`);
                            $("#tabDaolan").on("click",()=>{
                                that.infoServerMap.close();//初始关闭信息窗关闭
                                if(that.scenicSpotsID){
                                    const data = {
                                        filter: `[{"explanatio_id":${that.indoorId}},{"start":${that.scenicSpotsID}},{"end":"${event.target.id}"}]`
                                    }
                                    getIndoorVoiceRoute(data).then((res)=>{
                                        if(res.data.items.length == 0){
                                            Toast('暂无导航路线，请重新选择起点或终点');
                                        }else{
                                            that.CurrentRelevant = res.data.items[0]
                                            that.drawPath()
                                        }
                                    })
                                }
                                if(that.tolerantData.id){
                                    const data = {
                                        filter: `[{"explanatio_id":${that.indoorId}},{"start":${that.tolerantData.id}},{"end":"${event.target.id}"}]`
                                    }
                                    getIndoorVoiceRoute(data).then((res)=>{
                                        if(res.data.items.length == 0){
                                            Toast('暂无导航路线，请重新选择起点或终点');
                                        }else{
                                            that.CurrentRelevant = res.data.items[0]
                                            that.drawPath()
                                        }
                                    })
                                }
                            });
                        }
                    }
                })
            }
            if(this.searchSelets == 'search'){
                this.searchEstable()
            }
        },
        //  音频 时间处理
        formatTime(time) {
            let hour = parseInt(time / 3600);
            let min = parseInt((time / 60) % 60);
            let sec = parseInt(time % 60);
            if (hour.toString().length == 1) {
                hour = `0${hour}`;
            }
            if (min.toString().length == 1) {
                min = `0${min}`;
            }
            if (sec.toString().length == 1) {
                sec = `0${sec}`;
            }
            return `${min}:${sec}`;
        },
        //  展开遮罩层
        unfold(){
            this.showOptionHeigth = '5rem'
        },
        //  收回遮罩层
        takeBack(){
            this.showOptionHeigth = '2rem'
        },
        closeWin(){
            this.showOption = false
            this.RToptionShow = true
            if(this.CurrentRelevant.length != 0){
                this.CurrentShow = true
            }
        },
        //  去这里
        goThere(){
            this.infoServerMap.close();//初始关闭信息窗关闭
            if(this.scenicSpotsID){
                const data = {
                    filter: `[{"explanatio_id":${this.indoorId}},{"start":${this.scenicSpotsID}},{"end":"${this.pointInformationData.id}"}]`
                }
                getIndoorVoiceRoute(data).then((res)=>{
                    if(res.data.items.length == 0){
                        Toast('暂无导航路线，请重新选择起点或终点');
                    }else{
                        this.CurrentRelevant = res.data.items[0]
                        this.drawPath()
                    }
                })
            }else{
                const data = {
                    filter: `[{"explanatio_id":${this.indoorId}},{"start":${this.tolerantData.id}},{"end":"${this.pointInformationData.id}"}]`
                }
                getIndoorVoiceRoute(data).then((res)=>{
                    if(res.data.items.length == 0){
                        Toast('暂无导航路线，请重新选择起点或终点');
                    }else{
                        this.CurrentRelevant = res.data.items[0]
                        this.drawPath()
                    }
                })
            }
            this.showOption = false
            this.RToptionShow = true
            // this.CurrentShow = true
        },
        //  点击播放暂停 
        PlayAudio(){
            this.isPlay = !this.isPlay;
            let audio = this.$refs['maudit'];
            this.totleTime = audio.duration;
            this.totleTimeStr = this.formatTime(audio.duration);
            audio.ontimeupdate = () => {
                let time = audio.currentTime * 1;
                this.currentTimeStr = this.formatTime(time);
                this.currentTime = time;
            };
            this.isPlay ? audio.play() : audio.pause();
        },
        // 
        clickOverlay(){
            this.overlayShow = true
        },
        //  景点打开景点VR
        openVR(){
            window.open(this.pointInformationData.link_vr)
        },
        //  景点查看更多
        examineMore(){
            window.open(this.pointInformationData.link_spot)
        },
    },
};
</script>
<style  scoped lang="scss">
.van-popup--left{
    z-index: 9999990 !important;
}
.van-popup{
    background: none;
    box-sizing: border-box;
    padding-left: 0.1rem;
    padding-right: 0.1rem;
    overflow: hidden;
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .wrapperImg{
        width: 100%;
    }
}
html::-webkit-scrollbar{
        display: none;
    }
.indoorIndex{
    width: 100%;
    height: 100%;
    font-size: 0.14rem;

    .categoryTop{
        width: 100%;
        height: 0.44rem;
        position: fixed;
        top: 0;
        background: white;
        box-sizing: border-box;
        overflow: hidden; 
        overflow-x: scroll;
        white-space: nowrap;
        z-index: 2;
        .categoryName{
            height: 100%;
            font-size: 0.17rem;
            display: inline-block;
            position: relative;
            .imagesIcon{
                position: absolute;
                top: 0.12rem;
                left: 0.1rem;
                width: 0.2rem;
                height: 0.2rem;
                line-height: 0.5rem;
            }
            .cateName{
                line-height: 0.44rem;
                margin-left: 0.35rem;
                margin-right: 0.1rem;
                font-weight: 500;
            }
        }
    }
    .categoryTop::-webkit-scrollbar{
        display: none;
    }
    .LToption{
        margin: 0.1rem;
        width: 0.44rem;
        position: fixed;
        bottom: 0.6rem;
        z-index: 2;
        .FloorSelection{
            margin-top: 0.12rem;
            width: 0.44rem;
            height: 0.44rem;
            border-radius: 0.2rem;
            background: white;
            position: relative;
            .images{
                width: 100%;
                height: 100%;
            }
            .imagesMax{
                width: 0.22rem;
                height: 0.22rem;
                position: absolute;
                top: 0.11rem;
                left: 0.11rem;
            }
        }
        .FloorSelectionChild{
            width: 0.44rem;
            height: 0.44rem;
            border-radius: 0.2rem;
            background: white;
            margin-top: 0;
            position: relative;
            .floorOptions{
                width: 0.44rem;
                max-height: 1.86rem;
                background: white;
                border-radius: 0.2rem 0.2rem 0 0;
                position: absolute;
                bottom: 0.44rem;
                overflow: hidden;
                overflow-y: scroll;
                .coverageMark{
                    width: 0.3rem;
                    height: 0.3rem;
                    margin: 0.07rem;
                    border-radius: 50%;
                    .markSpa{
                        text-align: center;
                        line-height: 0.33rem;
                        display: flex;
                        flex-direction: column-reverse;
                    }
                }
            }
            .floorOptions::-webkit-scrollbar{
                display: none;
            }
            .FloorSelectionChildF{
                font-size: 0.13rem;
                position: absolute;
                top: 0.26rem;
                left: 0.16rem;
                font-weight: 900;
            }
            .images{
                position: absolute;
                top: 0.06rem;
                left: 0.11rem;
                width: 0.22rem;
                height: 0.22rem;
            }
            .ChildPlus{
                width: 0.22rem;
                height: 0.22rem;
                position: absolute;
                top: 0.11rem;
                left: 0.11rem;
            }
        }
    }
     .RToption{
        width: 0.44rem;
        background: white;
        position: fixed;
        top: 0.9rem;
        right: 0;
        margin: 0.1rem;
        border-radius: 0.22rem;
        padding: 0.06rem;
        box-sizing: border-box;
        z-index: 2;
        .RToptionCen{
            width: 100%;
            height: 0.5rem;
            margin-top: 0.05rem;
            .RToptionCenTop{
                width: 100%;
                height: 0.32rem;
                border-radius: 50%;
                position: relative;
                .imageCen{
                    width: 0.22rem;
                    height: 0.22rem;
                    position: absolute;
                    top: 0.05rem;
                    left: 0.05rem;
                }
            }
            .XX{
                background:linear-gradient(to bottom,#FFCFA8 ,#F97F1E);
            }
            .SC{
                background:linear-gradient(to bottom,#AFD3FF ,#1E84FE);
            }
            .XL{
                background:linear-gradient(to bottom,#FFB2B4 ,#FB4C4F);
            }
            .ZX{
                background:linear-gradient(to bottom,#e8f1c0 ,#b2e313);
            }
            .RToptionCenName{
                font-size: 0.12rem;
                text-align: center;
                line-height: 0.18rem;
                color:#707070 ;
            }
        }
        .RToptionCen:nth-child(1){
            margin-top: 0;
        }
    }
    .announcement{
        width: 94%;
        height: 0.3rem;
        margin: 0.1rem;
        position: fixed;
        top: 0.4rem;
        background: white;
        border-radius: 0.22rem;
        z-index: 2;
    }
    .playBack{
        width: 100%;
        height: 1.5rem;
        background: white;
        border-radius: 0.2rem;
        margin-bottom: 0.1rem;
        box-sizing: border-box;
        padding: 0.1rem;
        position: relative;
        .closeWin{
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.08rem;
            right: 0.08rem;
        }
        .ZKandSH{
            width: 100%;
            height: 0.25rem;
            font-size: 0.16rem;
            text-align: center;
            color: #707070  ;
        }
        .player{
            width: 100%;
            height: 0.96rem;
            .playerTop{
                display: flex;
                .playerTopLeft{
                    width: 0.5rem;
                    height: 0.5rem;
                    border-radius: 0.25rem;
                }
                .playerTopRig{
                    flex: 1;
                    height: 0.5rem;
                    margin-left: 0.15rem;
                    .playerName{
                        width: 100%;
                        height: 0.22rem;
                        font-size: 0.17rem;
                        color: #707070 ;
                    }
                    .playPlan{
                        width: 100%;
                        margin-top: 0.1rem ;
                        height: 0.18rem;
                        display: flex;
                        .playPlanL1{
                            width: 0.2rem;
                            height: 100%;
                        }
                        .playPlanL2{
                            width: 0.38rem;
                            height: 100%;
                            color: #707070 ;
                        }
                        .playPlanC{
                            flex: 1;
                            height: 100%;
                        }
                        .playPlanR1{
                            width: 0.38rem;
                            height: 100%;
                            text-align: right;
                            color: #707070 ;
                        }
                        .playPlanR2{
                            text-align: right;
                            width: 0.2rem;
                            height: 100%;
                        }
                    }
                }
            }
            .playerBtmID{
                width: 100%;
                height: 0.4rem;
                margin-top: 0.1rem;
                display: flex;
                .goToThisPlace{
                    width: 1rem;
                    height: 0.4rem;
                    border-radius: 0.2rem;
                    font-size: 0.16rem;
                    background: #EFEFF1;
                    text-align: center;
                    line-height: 0.4rem;
                    color: #707070 ;
                }
                .playerBtmExplain{
                    flex: 1;
                    margin-left: 0.1rem;
                    height: 0.4rem;
                    background: #E67008;
                    font-size: 0.16rem;
                    border-radius: 0.4rem;
                    text-align: center;
                    line-height: 0.4rem;
                    color: white;
                }
            }
            .playerBtm{
                width: 100%;
                margin-top: 0.1rem;
                height: 0.4rem;
                background: #E67008;
                font-size: 0.16rem;
                border-radius: 0.17rem;
                text-align: center;
                line-height: 0.4rem;
                color: white;
            }
        }
        
    }
    .Information{
        width: 100%;
        height: 3.4rem;
        background: white;
        border-radius: 0.2rem 0.2rem 0 0;
        padding: 0.1rem;
        box-sizing: border-box;
        .JDmessage{
            width:0.82rem;
            height: 0.24rem;
            font-size: 0.18rem;
            color: #707070 ;
            position: relative;
            background:linear-gradient(to bottom,white ,rgb(255,209,169));
            margin-bottom: 0.1rem;
        }
        .vrBackImg{
            width: 100%;
            height: 2.8rem;
            overflow: hidden;
            overflow-y: scroll;
            overflow-x: hidden;
            .vrImgBack{
                width: 100%;
                height: 0.9rem;
                display: flex;
                margin-bottom: 0.1rem;
                .vrImg{
                    width: 0.9rem;
                    height: 0.9rem;
                    background: yellow;
                    border-radius: 0.15rem;
                    
                }
                .backImg{
                    margin-left: 0.2rem;
                    width: 0.9rem;
                    height: 0.9rem;
                    background: blue;
                    border-radius: 0.15rem;
                    .backImgImages{
                        width: 100%;
                        height: 100%;
                        border-radius: 0.15rem;
                    }
                }
            }
            .scenicJD{
                font-size: 0.18rem;
                margin-bottom: 0.2rem;
                color: #707070;
            }
            .examineMore{
                width: 100%;
                height: 0.2rem;
                text-align: center;
                color: #707070;
                margin-bottom: 0.1rem;
            }
        }
        .vrBackImg::-webkit-scrollbar{
            display: none;
        }
    }
    .serchList{
        width: 100%;
        height: 100%;
        .notAvailable{
            font-size: 0.2rem;
            text-align: center;
            margin-top: 2rem;
            color:#707070 ;
        }
    }
    .notAvailable{
        font-size: 0.2rem;
        text-align: center;
        margin-top: 2rem;
    }
    .searchList{
        width: 100%;
        padding: 0.1rem;
        box-sizing: border-box;
        overflow: hidden;
        overflow-y: scroll;
        .serveDetails{
            width: 100%;
            margin-bottom: 0.1rem;
            padding: 0.05rem;
            box-sizing: border-box;
            height: 0.4rem;
            display: flex;
            .searchIcon{
                width: 0.3rem;
                height: 0.3rem;
                .Icons{
                    width: 100%;
                    height: 100%;
                }
            }
            .serveName{
                flex: 1;
                height: 0.3rem;
                font-size: 0.2rem;
                line-height: 0.3rem;
                margin-left: 0.05rem;
                color:#707070 ;
            }
        }
    }
    .chartCourseP{
        width:100%;
        height:100%;
        background:rgb(244, 246, 245);
        padding:0.1rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        .chartCourseM{
            width: 100%;
            height: 1.4rem;
            border-radius: 0.1rem;
            background: white;
            box-shadow: 0.05rem  0.05rem  0.05rem rgb(224, 224, 224);
            padding: 0.1rem;
            box-sizing: border-box;
            .chartCourseTop{
                width: 100%;
                height: 0.8rem;
                box-sizing: border-box;
                display: flex;
                .getBack{
                    width: 0.3rem;
                    height: 100%;
                    .images{
                        width: 0.3rem;
                        height: 0.3rem;
                    }
                }
                .chartCourseName{
                    flex: 1;
                    height: 0.8rem;
                    background: rgb(251, 251, 251);
                    border-radius: 0.1rem;
                    border: 0.01rem solid rgb(243, 243, 243) ;
                    .chartCourseNameTop{
                        width: 100%;
                        height: 0.35rem;
                        display: flex;
                        .chartCourseNameLeft{
                            width: 0.15rem;
                            height: 0.15rem;
                            box-sizing: border-box;
                            margin: 0.1rem;
                            border-radius: 50%;
                        }
                        .nameLeft{
                            background: rgb(99, 217, 126);
                        }
                        .nameRig{
                            background: rgb(229, 57, 48);
                        }
                        .chartCourseNameRig{
                            flex: 1;
                            height: 100%;
                            .courseInp{
                                width: 94%;
                                height: 0.28rem;
                                border: none;
                                background: #fbfbfb;
                            }
                        }
                    }
                    .NameTop{
                        margin-bottom: 0.1rem;
                    }
                }
            }
            .goToPlace{
                width: 100%;
                height: 0.3rem;
                margin-top: 0.1rem;
                position: relative;
                .goToButton{
                    position: absolute;
                    right: 0;
                    height: 100%;
                    width: 1.1rem;
                    border-radius: 0.2rem;
                    background: #E67008;
                    color: white;
                    text-align: center;
                    line-height: 0.3rem;
                    .goToImage{
                        position: absolute;
                        right: 0.15rem;
                        width: 0.25rem;
                    }
                }
            }
        }
        .chartDetailsPlus{
            width: 100%;
            height: 100%;
            padding: 0.1rem;
            box-sizing: border-box;
            border-radius: 0.1rem;
            background: white;
            margin-top: 0.2rem;
            box-shadow: 0.05rem  0.05rem  0.05rem rgb(224, 224, 224);
            display: flex;
            align-items: center;
            .zanwu{
                width: 100%;
                font-size: 0.2rem;
                text-align: center;
            }
        }
        .chartDetails{
            padding: 0.1rem;
            box-sizing: border-box;
            border-radius: 0.1rem;
            background: white;
            margin-top: 0.2rem;
            box-shadow: 0.05rem  0.05rem  0.05rem rgb(224, 224, 224);
            overflow: hidden;
            overflow-y: scroll;
            z-index: 999999999;
            //display: flex;
            //flex-direction: column;
            .chartDetailsList{
                width: 100%;
                height: 0.5rem;
                border-top: 0.01rem solid rgb(243, 243, 243) ;
                display: flex;
                .chartDetailsIcon{
                    width: 0.3rem;
                    height: 0.5rem;
                    box-sizing: border-box;
                    padding-top: 0.1rem;
                    padding-bottom: 0.1rem;
                }
                .chartDetailsName{
                    flex: 1;
                    height: 0.5rem;
                    box-sizing: border-box;
                    padding: 0.1rem;
                    font-size: 0.18rem;
                    line-height: 0.3rem;
                }
                .chartDetailsImage{
                    width: 0.5rem;
                    height: 0.5rem;
                    box-sizing: border-box;
                    padding: 0.1rem;
                }
            }
            .chartDetailsList:nth-child(1){
                border: none ;
            }
        }
    }
    .exitRoute{
        height: 0.3rem;
        width: 0.7rem;
        position: fixed;
        bottom: 0.9rem;
        right: 0;
        background: white;
        border-radius: 0.15rem;
        text-align: center;
        line-height: 0.32rem;
        border: 0.01rem solid #E67008;
        z-index: 2;
        margin-right: 0.2rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/index.vue